document.addEventListener('DOMContentLoaded', function() {
  // Size guide modal functionality
  const sizeGuideBtn = document.getElementById('fastrak_size-guide-btn');
  const sizeGuideModal = document.getElementById('fastrak_size-guide-modal');
  
  if (sizeGuideBtn && sizeGuideModal) {
    sizeGuideBtn.addEventListener('click', function() {
      sizeGuideModal.showModal();
      
      // Initialize size guide data when opening the modal
      initializeSizeGuide();
    });
    
    const closeModalBtn = sizeGuideModal.querySelector('.fastrak_js-close-modal');
    if (closeModalBtn) {
      closeModalBtn.addEventListener('click', function() {
        sizeGuideModal.close();
      });
    }
  }
  
  // Size guide data - hardcoded directly
  const sizeGuideData = {
    "helmets-adult": {
      "6D": {"sizes": [
        {"Helmet Size": "XS", "Size (cm)": "53 - 54 cm"},
        {"Helmet Size": "S", "Size (cm)": "55 - 56 cm"},
        {"Helmet Size": "M", "Size (cm)": "57 - 58 cm"},
        {"Helmet Size": "L", "Size (cm)": "58 - 59 cm"},
        {"Helmet Size": "XL", "Size (cm)": "60 - 61 cm"},
        {"Helmet Size": "XXL", "Size (cm)": "62 - 63 cm"}
      ]}
      ,
      "Airoh": {"sizes": [
        {"Helmet Size": "XSmall", "Size (cm)": "53 - 54 cms", "Size (in)": "20 ¾ - 21 ¼"},
        {"Helmet Size": "Small", "Size (cm)": "55 - 56 cms", "Size (in)": "21 ⅝ - 22"},
        {"Helmet Size": "Medium", "Size (cm)": "57 - 58 cms", "Size (in)": "22 ½ - 22 ⅞"},
        {"Helmet Size": "Large", "Size (cm)": "59 - 60 cms", "Size (in)": "23 ¼ - 23 ⅝"},
        {"Helmet Size": "XLarge", "Size (cm)": "61 - 62 cms", "Size (in)": "24 - 24 ½"},
        {"Helmet Size": "XXLarge", "Size (cm)": "63 cms", "Size (in)": "24 ¾"}
      ]},
      "Alpinestars": {"sizes": [
        {"Helmet Size": "XSmall", "Size (cm)": "53 - 54", "Size (in)": "20 ¾ - 21 ¼"},
        {"Helmet Size": "Small", "Size (cm)": "55 - 56", "Size (in)": "21 ⅝ - 22"},
        {"Helmet Size": "Medium", "Size (cm)": "57 - 58", "Size (in)": "22 ½ - 22 ⅞"},
        {"Helmet Size": "Large", "Size (cm)": "59 - 60", "Size (in)": "23 ¼ - 23 ⅝"},
        {"Helmet Size": "XLarge", "Size (cm)": "61 - 62", "Size (in)": "24 - 24 ½"},
        {"Helmet Size": "XXLarge", "Size (cm)": "63 - 64", "Size (in)": "24 ¾ - 25 ⅕"}
      ]},
      "Bell": {"sizes": [
        {"Helmet Size": "XSmall", "Size (cm)": "53 - 54 cms", "Size (in)": "20 ⅞ - 21 ⅝"},
        {"Helmet Size": "Small", "Size (cm)": "55 - 56 cms", "Size (in)": "21 ⅝ - 22"},
        {"Helmet Size": "Medium", "Size (cm)": "57 - 58 cms", "Size (in)": "22 ½ - 22 ¾"},
        {"Helmet Size": "Large", "Size (cm)": "59 - 60 cms", "Size (in)": "22 ¾ - 23 ¼"},
        {"Helmet Size": "XLarge", "Size (cm)": "61 - 62 cms", "Size (in)": "23 ⅝ - 24"},
        {"Helmet Size": "XXLarge", "Size (cm)": "63 - 64 cms", "Size (in)": "24 ½ - 24 ¾"}
      ]},
      "Fly Racing": {"sizes": [
        {"Helmet Size": "XSmall", "Size (cm)": "53 - 54 cms", "Size (in)": "20 ⅞ - 21 ¼"},
        {"Helmet Size": "Small", "Size (cm)": "55 - 56 cms", "Size (in)": "21 ⅝ - 22"},
        {"Helmet Size": "Medium", "Size (cm)": "57 - 58 cms", "Size (in)": "22 ½ - 22 ¾"},
        {"Helmet Size": "Large", "Size (cm)": "59 - 60 cms", "Size (in)": "23 ¼ - 23 ⅝"},
        {"Helmet Size": "XLarge", "Size (cm)": "61 - 62 cms", "Size (in)": "24 - 24 ½"},
        {"Helmet Size": "XXLarge", "Size (cm)": "63 - 64 cms", "Size (in)": "24 ¾ - 25 ⅕"}
      ]},
      "Fox Racing": {"sizes": [
        {"Helmet Size": "XSmall", "Size (cm)": "53 - 54 cms", "Size (in)": "20 ⅞ - 21 ⅝"},
        {"Helmet Size": "Small", "Size (cm)": "55 - 56 cms", "Size (in)": "21 ⅝ - 22"},
        {"Helmet Size": "Medium", "Size (cm)": "57 - 58 cms", "Size (in)": "22 ½ - 22 ¾"},
        {"Helmet Size": "Large", "Size (cm)": "59 - 60 cms", "Size (in)": "22 ¾ - 23 ¼"},
        {"Helmet Size": "XLarge", "Size (cm)": "61 - 62 cms", "Size (in)": "23 ⅝ - 24"},
        {"Helmet Size": "XXLarge", "Size (cm)": "63 - 64 cms", "Size (in)": "24 ½ - 24 ¾"}
      ]},
      "Leatt": {"sizes": [
        {"Helmet Size": "XSmall", "Size (cm)": "53 - 54 cms", "Size (in)": "20 ¾ - 21 ¼"},
        {"Helmet Size": "Small", "Size (cm)": "55 - 56 cms", "Size (in)": "21 ⅝ - 22"},
        {"Helmet Size": "Medium", "Size (cm)": "57 - 58 cms", "Size (in)": "22 ½ - 22 ¾"},
        {"Helmet Size": "Large", "Size (cm)": "59 - 60 cms", "Size (in)": "23 ¼ - 23 ⅝"},
        {"Helmet Size": "XLarge", "Size (cm)": "61 - 62 cms", "Size (in)": "24 - 24 ½"},
        {"Helmet Size": "XXLarge", "Size (cm)": "63 - 64 cms", "Size (in)": "24 ¾ - 25 ⅕"}
      ]},
      "ONeal": {"sizes": [
        {"Helmet Size": "XSmall", "Size (cm)": "53 - 54 cms", "Size (in)": "20 ¾ - 21 ¼"},
        {"Helmet Size": "Small", "Size (cm)": "55 - 56 cms", "Size (in)": "21 ⅝ - 22"},
        {"Helmet Size": "Medium", "Size (cm)": "57 - 58 cms", "Size (in)": "22 ½ - 22 ⅞"},
        {"Helmet Size": "Large", "Size (cm)": "59 - 60 cms", "Size (in)": "23 ¼ - 23 ⅝"},
        {"Helmet Size": "XLarge", "Size (cm)": "61 - 62 cms", "Size (in)": "24 - 24 ½"},
        {"Helmet Size": "XXLarge", "Size (cm)": "63 - 64 cms", "Size (in)": "24 ¾ - 25 ⅕"}
      ]},
      "Troy Lee Designs": {"sizes": [
        {"Helmet Size": "XSmall", "Size (cm)": "53 - 54 cms", "Size (in)": "20 ⅞ - 21 ¼"},
        {"Helmet Size": "Small", "Size (cm)": "55 - 56 cms", "Size (in)": "21 ⅝ - 22"},
        {"Helmet Size": "Medium", "Size (cm)": "57 - 58 cms", "Size (in)": "22 ½ - 22 ¾"},
        {"Helmet Size": "Large", "Size (cm)": "59 - 60 cms", "Size (in)": "23 ¼ - 23 ⅝"},
        {"Helmet Size": "XLarge", "Size (cm)": "61 - 62 cms", "Size (in)": "24 - 24 ½"},
        {"Helmet Size": "XXLarge", "Size (cm)": "63 - 64 cms", "Size (in)": "24 ¾ - 25 ⅕"}
      ]}
    },
    "helmets-youth": {
      "6D": {"sizes": [
        {"Helmet Size": "YSM", "Size (cm)": "49 - 50 cm"},
        {"Helmet Size": "YMD", "Size (cm)": "50 - 51 cm"},
        {"Helmet Size": "YLG", "Size (cm)": "51 - 52 cm"},
        {"Helmet Size": "YXL", "Size (cm)": "52 - 53 cm"}
      ]},
      "Alpinestars": {"sizes": [
        {"Helmet Size": "Small", "Size (cm)": "48 - 49 cms", "Size (in)": "18 ¾ - 19 ¼"},
        {"Helmet Size": "Medium", "Size (cm)": "50 - 51 cms", "Size (in)": "19 ⅝ - 19 ⅞"},
        {"Helmet Size": "Large", "Size (cm)": "52 - 53 cms", "Size (in)": "20 ⅕ - 20 ½"}
      ]},
      "Fly": {"sizes": [
        {"Helmet Size": "Small", "Size (cm)": "47 - 48 cms", "Size (in)": "18 ¼ - 19"},
        {"Helmet Size": "Medium", "Size (cm)": "49 - 50 cms", "Size (in)": "19 ⅛ - 19 ¾"},
        {"Helmet Size": "Large", "Size (cm)": "51 - 52 cms", "Size (in)": "19 ⅞ - 20 ⅕"}
      ]},
      "Fox": {"sizes": [
        {"Helmet Size": "Small", "Size (cm)": "47 - 48 cms", "Size (in)": "18 ⅕ - 18 ⅞"},
        {"Helmet Size": "Medium", "Size (cm)": "49 - 50 cms", "Size (in)": "19 ¼ - 19 ⅝"},
        {"Helmet Size": "Large", "Size (cm)": "51 - 52 cms", "Size (in)": "20 - 20 ⅕"}
      ]},
      "Troy Lee designs": {"sizes": [
        {"Helmet Size": "Medium", "Size (cm)": "50 - 51 cms", "Size (in)": "19 ¾ - 20 ⅛"},
        {"Helmet Size": "Large", "Size (cm)": "52 - 53 cms", "Size (in)": "20 ⅕ - 20 ⅞"}
      ]}
    },
    "boots-adult": {
      "Alpinestars": {"sizes": [
        {"UK Size": "UK 7", "Euro Size": "Euro 42", "US Size": "US 8"},
        {"UK Size": "UK 8", "Euro Size": "Euro 43", "US Size": "US 9"},
        {"UK Size": "UK 9", "Euro Size": "Euro 44.5", "US Size": "US 10"},
        {"UK Size": "UK 10", "Euro Size": "Euro 45.5", "US Size": "US 11"},
        {"UK Size": "UK 11", "Euro Size": "Euro 47", "US Size": "US 12"},
        {"UK Size": "UK 12", "Euro Size": "Euro 48", "US Size": "US 13"},
        {"UK Size": "UK 13", "Euro Size": "Euro 49.5", "US Size": "US 14"}
      ]},
      "Fly Racing": {"sizes": [
        {"UK Size": "UK 7", "Euro Size": "Euro 42", "US Size": "US 8"},
        {"UK Size": "UK 8", "Euro Size": "Euro 43", "US Size": "US 9"},
        {"UK Size": "UK 9", "Euro Size": "Euro 45", "US Size": "US 10"},
        {"UK Size": "UK 10", "Euro Size": "Euro 46", "US Size": "US 11"},
        {"UK Size": "UK 11", "Euro Size": "Euro 47", "US Size": "US 12"},
        {"UK Size": "UK 12", "Euro Size": "Euro 48", "US Size": "US 13"},
        {"UK Size": "UK 13", "Euro Size": "Euro 50", "US Size": "US 14"}
      ]},
      "Fox": {"sizes": [
        {"UK Size": "UK 7", "Euro Size": "Euro 41", "US Size": "US 8"},
        {"UK Size": "UK 8", "Euro Size": "Euro 42.5", "US Size": "US 9"},
        {"UK Size": "UK 9", "Euro Size": "Euro 44", "US Size": "US 10"},
        {"UK Size": "UK 10", "Euro Size": "Euro 45", "US Size": "US 11"},
        {"UK Size": "UK 11", "Euro Size": "Euro 46", "US Size": "US 12"},
        {"UK Size": "UK 12", "Euro Size": "Euro 47.5", "US Size": "US 13"},
        {"UK Size": "UK 13", "Euro Size": "Euro 49", "US Size": "US 14"}
      ]},
      "Gaerne": {"sizes": [
        {"UK Size": "UK 6", "Euro Size": "Euro 41"},
        {"UK Size": "UK 7", "Euro Size": "Euro 42"},
        {"UK Size": "UK 8", "Euro Size": "Euro 43"},
        {"UK Size": "UK 8.5", "Euro Size": "Euro 44"},
        {"UK Size": "UK 9.5", "Euro Size": "Euro 45"},
        {"UK Size": "UK 10", "Euro Size": "Euro 46"},
        {"UK Size": "UK 11", "Euro Size": "Euro 47"},
        {"UK Size": "UK 12", "Euro Size": "Euro 48"},
        {"UK Size": "UK 13", "Euro Size": "Euro 49"}
      ]},
      "Leatt": {"sizes": [
        {"UK Size": "UK 7", "Euro Size": "Euro 42", "US Size": "US 8"},
        {"UK Size": "UK 8", "Euro Size": "Euro 43", "US Size": "US 9"},
        {"UK Size": "UK 9", "Euro Size": "Euro 44.5", "US Size": "US 10"},
        {"UK Size": "UK 10", "Euro Size": "Euro 45.5", "US Size": "US 11"},
        {"UK Size": "UK 11", "Euro Size": "Euro 47", "US Size": "US 12"},
        {"UK Size": "UK 12", "Euro Size": "Euro 48", "US Size": "US 13"}
      ]},
      "O'Neal": {"sizes": [
        {"UK Size": "UK 7", "Euro Size": "Euro 41", "US Size": "US 8"},
        {"UK Size": "UK 8", "Euro Size": "Euro 42", "US Size": "US 9"},
        {"UK Size": "UK 9", "Euro Size": "Euro 43", "US Size": "US 10"},
        {"UK Size": "UK 9.5", "Euro Size": "Euro 44", "US Size": "US 10.5"},
        {"UK Size": "UK 10", "Euro Size": "Euro 45", "US Size": "US 11"},
        {"UK Size": "UK 11", "Euro Size": "Euro 46", "US Size": "US 12"},
        {"UK Size": "UK 12", "Euro Size": "Euro 47", "US Size": "US 13"},
        {"UK Size": "UK 13", "Euro Size": "Euro 48", "US Size": "US 14"},
        {"UK Size": "UK 14", "Euro Size": "Euro 49", "US Size": "US 15"}
      ]},
      "Sidi": {"sizes": [
        {"UK Size": "UK 7", "Euro Size": "Euro 41", "US Size": "US 8"},
        {"UK Size": "UK 8", "Euro Size": "Euro 42", "US Size": "US 9"},
        {"UK Size": "UK 9", "Euro Size": "Euro 43", "US Size": "US 9.5"},
        {"UK Size": "UK 9.5", "Euro Size": "Euro 44", "US Size": "US 10"},
        {"UK Size": "UK 10.5", "Euro Size": "Euro 45", "US Size": "US 11"},
        {"UK Size": "UK 11", "Euro Size": "Euro 46", "US Size": "US 11.5"},
        {"UK Size": "UK 12", "Euro Size": "Euro 47", "US Size": "US 12.5"},
        {"UK Size": "UK 12.5", "Euro Size": "Euro 48", "US Size": "US 13"},
        {"UK Size": "UK 13.5", "Euro Size": "Euro 49", "US Size": "US 14"},
        {"UK Size": "UK 14", "Euro Size": "Euro 50", "US Size": "US 15"}
      ]}
    },
    "boots-youth": {
      "Alpinestars": {"sizes": [
        {"UK Size": "UK 9 (Kids)", "Euro Size": "Euro 28", "US Size": "US 10 (Kids)"},
        {"UK Size": "UK 10 (Kids)", "Euro Size": "Euro 29", "US Size": "US 11 (Kids)"},
        {"UK Size": "UK 11 (Kids)", "Euro Size": "Euro 30.5", "US Size": "US 12 (Kids)"},
        {"UK Size": "UK 12 (Kids)", "Euro Size": "Euro 32", "US Size": "US 13 (Kids)"},
        {"UK Size": "UK 13 (Kids)", "Euro Size": "Euro 33", "US Size": "US 1"},
        {"UK Size": "UK 1", "Euro Size": "Euro 34", "US Size": "US 2"},
        {"UK Size": "UK 2", "Euro Size": "Euro 35.5", "US Size": "US 3"},
        {"UK Size": "UK 3", "Euro Size": "Euro 37", "US Size": "US 4"},
        {"UK Size": "UK 4", "Euro Size": "Euro 38", "US Size": "US 5"},
        {"UK Size": "UK 5", "Euro Size": "Euro 39", "US Size": "US 6"},
        {"UK Size": "UK 6", "Euro Size": "Euro 40.5", "US Size": "US 7"},
        {"UK Size": "UK 7", "Euro Size": "Euro 42", "US Size": "US 8"}
      ]},
      "Fox": {"sizes": [
        {"UK Size": "UK 9 (Kids)", "Euro Size": "Euro 27", "US Size": "US 10 (Kids)"},
        {"UK Size": "UK 10 (Kids)", "Euro Size": "Euro 28", "US Size": "US 11 (Kids)"},
        {"UK Size": "UK 11 (Kids)", "Euro Size": "Euro 29", "US Size": "US 12 (Kids)"},
        {"UK Size": "UK 12 (Kids)", "Euro Size": "Euro 31", "US Size": "US 13 (Kids)"},
        {"UK Size": "UK 13 (Kids)", "Euro Size": "Euro 32", "US Size": "US 1"},
        {"UK Size": "UK 1", "Euro Size": "Euro 33.5", "US Size": "US 2"},
        {"UK Size": "UK 2", "Euro Size": "Euro 35", "US Size": "US 3"},
        {"UK Size": "UK 3", "Euro Size": "Euro 36", "US Size": "US 4"},
        {"UK Size": "UK 4", "Euro Size": "Euro 37.5", "US Size": "US 5"},
        {"UK Size": "UK 5", "Euro Size": "Euro 39", "US Size": "US 7"},
        {"UK Size": "UK 6", "Euro Size": "Euro 40", "US Size": "US 7.5"},
        {"UK Size": "UK 7", "Euro Size": "Euro 41", "US Size": "US 8"}
      ]},
      "Gaerne": {"sizes": [
        {"UK Size": "UK 1", "Euro Size": "Euro 33"},
        {"UK Size": "UK 2", "Euro Size": "Euro 34"},
        {"UK Size": "UK 2.5", "Euro Size": "Euro 35"},
        {"UK Size": "UK 3.5", "Euro Size": "Euro 36"},
        {"UK Size": "UK 4", "Euro Size": "Euro 37"},
        {"UK Size": "UK 5", "Euro Size": "Euro 38"},
        {"UK Size": "UK 5.5", "Euro Size": "Euro 39"},
        {"UK Size": "UK 6", "Euro Size": "Euro 40"},
        {"UK Size": "UK 7", "Euro Size": "Euro 41"}
      ]}
    },
    "jersey-adult": {
      "Alpinestars": {"sizes": [
        {"Jersey Size": "Small", "Chest Size (cm)": "90 - 96 cms", "Chest Size (in)": "32 ½ - 37 ¾ ins"},
        {"Jersey Size": "Medium", "Chest Size (cm)": "96 - 100 cms", "Chest Size (in)": "37 ¾ - 39 ⅜ ins"},
        {"Jersey Size": "Large", "Chest Size (cm)": "100 - 106 cms", "Chest Size (in)": "39 ⅜ - 41 ¾ ins"},
        {"Jersey Size": "XLarge", "Chest Size (cm)": "106 - 112 cms", "Chest Size (in)": "41 ¾ - 44 ins"},
        {"Jersey Size": "XXLarge", "Chest Size (cm)": "112 - 118 cms", "Chest Size (in)": "44 - 46 ½ ins"},
        {"Jersey Size": "3XLarge", "Chest Size (cm)": "118 - 124 cms", "Chest Size (in)": "46 ½ - 48 ¾ ins"},
        {"Jersey Size": "4XLarge", "Chest Size (cm)": "124 - 130 cms", "Chest Size (in)": "48 ¾ - 51 ¼ ins"}
      ]},
      "Fly Racing": {"sizes": [
        {"Jersey Size": "Small", "Chest Size (cm)": "86 - 89 cms", "Chest Size (in)": "34 - 35 ins"},
        {"Jersey Size": "Medium", "Chest Size (cm)": "91 - 96 cms", "Chest Size (in)": "36 - 38 ins"},
        {"Jersey Size": "Large", "Chest Size (cm)": "102 - 107 cms", "Chest Size (in)": "40 - 42 ins"},
        {"Jersey Size": "XLarge", "Chest Size (cm)": "112 - 117 cms", "Chest Size (in)": "44 - 46 ins"},
        {"Jersey Size": "XXLarge", "Chest Size (cm)": "122 - 127 cms", "Chest Size (in)": "48 - 50 ins"},
        {"Jersey Size": "3XLarge", "Chest Size (cm)": "132 - 137 cms", "Chest Size (in)": "52 - 54 ins"},
        {"Jersey Size": "4XLarge", "Chest Size (cm)": "142 - 147 cms", "Chest Size (in)": "56 - 58 ins"},
        {"Jersey Size": "5XLarge", "Chest Size (cm)": "152 - 157 cms", "Chest Size (in)": "60 - 62 ins"}
      ]},
      "Fox": {"sizes": [
        {"Jersey Size": "Small", "Chest Size (cm)": "86 - 89 cms", "Chest Size (in)": "33 ¾ - 35 ins"},
        {"Jersey Size": "Medium", "Chest Size (cm)": "91 - 92 cms", "Chest Size (in)": "35 ¾ - 36 ¼ ins"},
        {"Jersey Size": "Large", "Chest Size (cm)": "102 - 107 cms", "Chest Size (in)": "39 ⅜ - 42 ins"},
        {"Jersey Size": "XLarge", "Chest Size (cm)": "112 - 117 cms", "Chest Size (in)": "42 ¼ - 46 ins"},
        {"Jersey Size": "XXLarge", "Chest Size (cm)": "122 - 127 cms", "Chest Size (in)": "48 - 50 ins"},
        {"Jersey Size": "3XLarge", "Chest Size (cm)": "132 - 137 cms", "Chest Size (in)": "51 ½ - 54 ins"}
      ]},
      "Leatt": {"sizes": [
        {"Jersey Size": "Small", "Chest Size (cm)": "96 - 102 cms", "Chest Size (in)": "38 - 40 ins"},
        {"Jersey Size": "Medium", "Chest Size (cm)": "102 - 106 cms", "Chest Size (in)": "40 - 42 ins"},
        {"Jersey Size": "Large", "Chest Size (cm)": "106 - 112 cms", "Chest Size (in)": "42 - 44 ins"},
        {"Jersey Size": "XLarge", "Chest Size (cm)": "112 - 116 cms", "Chest Size (in)": "44 - 46 ins"},
        {"Jersey Size": "XXLarge", "Chest Size (cm)": "116 - 122 cms", "Chest Size (in)": "46 - 48 ins"}
      ]},
      "O'Neal": {"sizes": [
        {"Jersey Size": "Small", "Chest Size (cm)": "100 - 106 cms", "Chest Size (in)": "39 ¼ - 41 ¾ ins"},
        {"Jersey Size": "Medium", "Chest Size (cm)": "107 - 114 cms", "Chest Size (in)": "42 - 44 ¾ ins"},
        {"Jersey Size": "Large", "Chest Size (cm)": "116 - 122 cms", "Chest Size (in)": "45 ½ - 48 ins"},
        {"Jersey Size": "XLarge", "Chest Size (cm)": "124 - 128 cms", "Chest Size (in)": "48 ¾ - 50 ½ ins"},
        {"Jersey Size": "XXLarge", "Chest Size (cm)": "134 - 138 cms", "Chest Size (in)": "52 - 54 ¼ ins"},
        {"Jersey Size": "3XLarge", "Chest Size (cm)": "138 - 144 cms", "Chest Size (in)": "54 ½ - 56 ½ ins"}
      ]},
      "Seven": {"sizes": [
        {"Jersey Size": "Small", "Chest Size (cm)": "102 - 106 cms", "Chest Size (in)": "40 - 42 ins"},
        {"Jersey Size": "Medium", "Chest Size (cm)": "106 - 112 cms", "Chest Size (in)": "42 - 44 ins"},
        {"Jersey Size": "Large", "Chest Size (cm)": "112 - 116 cms", "Chest Size (in)": "44 - 46 ins"},
        {"Jersey Size": "XLarge", "Chest Size (cm)": "116 - 122 cms", "Chest Size (in)": "46 - 47 ins"},
        {"Jersey Size": "XXLarge", "Chest Size (cm)": "122 - 130 cms", "Chest Size (in)": "48 - 51 ins"}
      ]},
      "Troy Lee Designs": {"sizes": [
        {"Jersey Size": "Small", "Chest Size (cm)": "102 - 106 cms", "Chest Size (in)": "40 - 42 ins"},
        {"Jersey Size": "Medium", "Chest Size (cm)": "106 - 112 cms", "Chest Size (in)": "42 - 44 ins"},
        {"Jersey Size": "Large", "Chest Size (cm)": "112 - 116 cms", "Chest Size (in)": "44 - 46 ins"},
        {"Jersey Size": "XLarge", "Chest Size (cm)": "116 - 119 cms", "Chest Size (in)": "46 - 47 ins"},
        {"Jersey Size": "XXLarge", "Chest Size (cm)": "122 - 130 cms", "Chest Size (in)": "48 - 51 ins"}
      ]}
    },
    "jersey-youth": {
      "Alpinestars": {"sizes": [
        {"Jersey Size": "Small", "Chest Size (cm)": "60 - 65 cms", "Chest Size (in)": "23 ⅞ - 25 ¾ ins"},
        {"Jersey Size": "Medium", "Chest Size (cm)": "65 - 70 cms", "Chest Size (in)": "25 ¾ - 27 ¾ ins"},
        {"Jersey Size": "Large", "Chest Size (cm)": "70 - 75 cms", "Chest Size (in)": "27 ¾ - 29 ¾ ins"},
        {"Jersey Size": "XLarge", "Chest Size (cm)": "75 - 80 cms", "Chest Size (in)": "29 ¾ - 31 ¾ ins"}
      ]},
      "Fly Racing": {"sizes": [
        {"Jersey Size": "Small", "Chest Size (cm)": "51 - 56 cms", "Chest Size (in)": "20 - 22 ins"},
        {"Jersey Size": "Medium", "Chest Size (cm)": "61 - 66 cms", "Chest Size (in)": "24 - 26 ins"},
        {"Jersey Size": "Large", "Chest Size (cm)": "71 - 76 cms", "Chest Size (in)": "28 - 30 ins"},
        {"Jersey Size": "XLarge", "Chest Size (cm)": "81 - 86 cms", "Chest Size (in)": "32 - 34 ins"}
      ]},
      "Fox": {"sizes": [
        {"Jersey Size": "Small", "Chest Size (cm)": "62 cms", "Chest Size (in)": "24 ½ ins"},
        {"Jersey Size": "Medium", "Chest Size (cm)": "67 cms", "Chest Size (in)": "26 ⅜ ins"},
        {"Jersey Size": "Large", "Chest Size (cm)": "71 cms", "Chest Size (in)": "28 ins"},
        {"Jersey Size": "XLarge", "Chest Size (cm)": "75 cms", "Chest Size (in)": "29 ½ ins"}
      ]},
      "Leatt": {"sizes": [
        {"Jersey Size": "XXSmall", "Chest Size (cm)": "61 - 66 cms", "Chest Size (in)": "24 - 26 ins"},
        {"Jersey Size": "XSmall", "Chest Size (cm)": "66 - 71 cms", "Chest Size (in)": "26 - 28 ins"},
        {"Jersey Size": "Small", "Chest Size (cm)": "71 - 76 cms", "Chest Size (in)": "28 - 30 ins"},
        {"Jersey Size": "Medium", "Chest Size (cm)": "76 - 81 cms", "Chest Size (in)": "30 - 32 ins"},
        {"Jersey Size": "Large", "Chest Size (cm)": "81 - 86 cms", "Chest Size (in)": "32 - 34 ins"},
        {"Jersey Size": "XLarge", "Chest Size (cm)": "86 - 91 cms", "Chest Size (in)": "34 - 36 ins"}
      ]},
      "Seven": {"sizes": [
        {"Jersey Size": "XXSmall", "Chest Size (cm)": "61 cms", "Chest Size (in)": "24 ins"},
        {"Jersey Size": "XSmall", "Chest Size (cm)": "71 cms", "Chest Size (in)": "28 ins"},
        {"Jersey Size": "Small", "Chest Size (cm)": "76 cms", "Chest Size (in)": "30 ins"},
        {"Jersey Size": "Medium", "Chest Size (cm)": "84 cms", "Chest Size (in)": "33 ins"},
        {"Jersey Size": "Large", "Chest Size (cm)": "91 cms", "Chest Size (in)": "36 ins"},
        {"Jersey Size": "XLarge", "Chest Size (cm)": "96 cms", "Chest Size (in)": "38 ins"}
      ]},
      "Troy Lee Designs": {"sizes": [
        {"Jersey Size": "XSmall", "Chest Size (cm)": "71 cms", "Chest Size (in)": "28 ins"},
        {"Jersey Size": "Small", "Chest Size (cm)": "78 cms", "Chest Size (in)": "31 ins"},
        {"Jersey Size": "Medium", "Chest Size (cm)": "86 cms", "Chest Size (in)": "34 ins"},
        {"Jersey Size": "Large", "Chest Size (cm)": "91 cms", "Chest Size (in)": "36 ins"},
        {"Jersey Size": "XLarge", "Chest Size (cm)": "102 cms", "Chest Size (in)": "40 ins"}
      ]}
    },
    "pant-adult": {
      "Alpinestars": {"sizes": [
        {"Pant Size": "28 ins", "Waist Size (cm)": "72 - 76 cms", "Euro Size": "44"},
        {"Pant Size": "30 ins", "Waist Size (cm)": "76 - 80 cms", "Euro Size": "46"},
        {"Pant Size": "32 ins", "Waist Size (cm)": "80 - 84 cms", "Euro Size": "48"},
        {"Pant Size": "34 ins", "Waist Size (cm)": "84 - 88 cms", "Euro Size": "50"},
        {"Pant Size": "36 ins", "Waist Size (cm)": "88 - 92 cms", "Euro Size": "52"},
        {"Pant Size": "38 ins", "Waist Size (cm)": "92 - 96 cms", "Euro Size": "54"},
        {"Pant Size": "40 ins", "Waist Size (cm)": "96 - 100 cms", "Euro Size": "56"},
        {"Pant Size": "42 ins", "Waist Size (cm)": "100 - 104 cms", "Euro Size": "58"}
      ]},
      "Fly Racing": {"sizes": [
        {"Pant Size": "28 ins", "Waist Size (cm)": "72 - 76 cms", "Euro Size": "44"},
        {"Pant Size": "30 ins", "Waist Size (cm)": "76 - 80 cms", "Euro Size": "46"},
        {"Pant Size": "32 ins", "Waist Size (cm)": "80 - 84 cms", "Euro Size": "48"},
        {"Pant Size": "34 ins", "Waist Size (cm)": "84 - 88 cms", "Euro Size": "50"},
        {"Pant Size": "36 ins", "Waist Size (cm)": "88 - 92 cms", "Euro Size": "52"},
        {"Pant Size": "38 ins", "Waist Size (cm)": "92 - 96 cms", "Euro Size": "54"},
        {"Pant Size": "40 ins", "Waist Size (cm)": "96 - 100 cms", "Euro Size": "56"},
        {"Pant Size": "42 ins", "Waist Size (cm)": "100 - 104 cms", "Euro Size": "58"},
        {"Pant Size": "44 ins", "Waist Size (cm)": "104 - 108 cms", "Euro Size": "60"},
        {"Pant Size": "46 ins", "Waist Size (cm)": "108 - 112 cms", "Euro Size": "62"},
        {"Pant Size": "48 ins", "Waist Size (cm)": "112 - 116 cms", "Euro Size": "64"}
      ]},
      "Fox": {"sizes": [
        {"Pant Size": "28 ins", "Waist Size (cm)": "69 - 74 cms", "Euro Size": "37"},
        {"Pant Size": "30 ins", "Waist Size (cm)": "74 - 79 cms", "Euro Size": "38 - 40"},
        {"Pant Size": "32 ins", "Waist Size (cm)": "79 - 84 cms", "Euro Size": "40"},
        {"Pant Size": "34 ins", "Waist Size (cm)": "84 - 89 cms", "Euro Size": "40 - 42"},
        {"Pant Size": "36 ins", "Waist Size (cm)": "89 - 94 cms", "Euro Size": "42"},
        {"Pant Size": "38 ins", "Waist Size (cm)": "94 - 99 cms", "Euro Size": "42 - 44"},
        {"Pant Size": "40 ins", "Waist Size (cm)": "99 - 104 cms", "Euro Size": "44"}
      ]},
      "Leatt": {"sizes": [
        {"Pant Size": "28 ins", "Waist Size (cm)": "68 - 73 cms", "Euro Size": "44"},
        {"Pant Size": "30 ins", "Waist Size (cm)": "73 - 78 cms", "Euro Size": "46"},
        {"Pant Size": "32 ins", "Waist Size (cm)": "78 - 83 cms", "Euro Size": "48"},
        {"Pant Size": "34 ins", "Waist Size (cm)": "83 - 88 cms", "Euro Size": "50"},
        {"Pant Size": "36 ins", "Waist Size (cm)": "88 - 93 cms", "Euro Size": "52"},
        {"Pant Size": "38 ins", "Waist Size (cm)": "93 - 99 cms", "Euro Size": "54"},
        {"Pant Size": "40 ins", "Waist Size (cm)": "99 - 104 cms", "Euro Size": "56"},
        {"Pant Size": "42 ins", "Waist Size (cm)": "104 - 109 cms", "Euro Size": "58"},
        {"Pant Size": "44 ins", "Waist Size (cm)": "109 - 115 cms", "Euro Size": "60"}
      ]},
      "O'Neal": {"sizes": [
        {"Pant Size": "28 ins", "Waist Size (cm)": "72 - 76 cms", "Euro Size": "44"},
        {"Pant Size": "30 ins", "Waist Size (cm)": "76 - 80 cms", "Euro Size": "46"},
        {"Pant Size": "32 ins", "Waist Size (cm)": "80 - 84 cms", "Euro Size": "48"},
        {"Pant Size": "34 ins", "Waist Size (cm)": "84 - 88 cms", "Euro Size": "50"},
        {"Pant Size": "36 ins", "Waist Size (cm)": "88 - 92 cms", "Euro Size": "52"},
        {"Pant Size": "38 ins", "Waist Size (cm)": "92 - 96 cms", "Euro Size": "54"},
        {"Pant Size": "40 ins", "Waist Size (cm)": "96 - 100 cms", "Euro Size": "56"},
        {"Pant Size": "42 ins", "Waist Size (cm)": "100 - 104 cms", "Euro Size": "58"}
      ]},
      "Seven": {"sizes": [
        {"Pant Size": "28 ins", "Waist Size (cm)": "72 - 76 cms", "Euro Size": "44"},
        {"Pant Size": "30 ins", "Waist Size (cm)": "76 - 80 cms", "Euro Size": "46"},
        {"Pant Size": "32 ins", "Waist Size (cm)": "80 - 84 cms", "Euro Size": "48"},
        {"Pant Size": "34 ins", "Waist Size (cm)": "84 - 88 cms", "Euro Size": "50"},
        {"Pant Size": "36 ins", "Waist Size (cm)": "88 - 92 cms", "Euro Size": "52"},
        {"Pant Size": "38 ins", "Waist Size (cm)": "92 - 96 cms", "Euro Size": "54"},
        {"Pant Size": "40 ins", "Waist Size (cm)": "96 - 100 cms", "Euro Size": "56"},
        {"Pant Size": "42 ins", "Waist Size (cm)": "100 - 104 cms", "Euro Size": "58"}
      ]},
      "Troy Lee Designs": {"sizes": [
        {"Pant Size": "28 ins", "Waist Size (cm)": "72 - 76 cms", "Euro Size": "44"},
        {"Pant Size": "30 ins", "Waist Size (cm)": "76 - 80 cms", "Euro Size": "46"},
        {"Pant Size": "32 ins", "Waist Size (cm)": "80 - 84 cms", "Euro Size": "48"},
        {"Pant Size": "34 ins", "Waist Size (cm)": "84 - 88 cms", "Euro Size": "50"},
        {"Pant Size": "36 ins", "Waist Size (cm)": "88 - 92 cms", "Euro Size": "52"},
        {"Pant Size": "38 ins", "Waist Size (cm)": "92 - 96 cms", "Euro Size": "54"},
        {"Pant Size": "40 ins", "Waist Size (cm)": "96 - 100 cms", "Euro Size": "56"},
        {"Pant Size": "42 ins", "Waist Size (cm)": "100 - 104 cms", "Euro Size": "58"}
      ]}
    },
    "pant-youth": {
      "Alpinestars": {"sizes": [
        {"Pant Size": "22 ins", "Waist Size (cm)": "60 - 65 cms", "Waist Size (in)": "23 ⅝ - 25 ½ ins"},
        {"Pant Size": "24 ins", "Waist Size (cm)": "65 - 70 cms", "Waist Size (in)": "25 ½ - 27 ½ ins"},
        {"Pant Size": "26 ins", "Waist Size (cm)": "70 - 75 cms", "Waist Size (in)": "27 ½ - 29 ½ ins"},
        {"Pant Size": "28 ins", "Waist Size (cm)": "75 - 80 cms", "Waist Size (in)": "29 ½ - 31 ½ ins"}
      ]},
      "Fly Racing": {"sizes": [
        {"Pant Size": "18 ins", "Waist Size (cm)": "47 - 51 cms", "Waist Size (in)": "18 ½ - 20 ins"},
        {"Pant Size": "20 ins", "Waist Size (cm)": "52 - 56 cms", "Waist Size (in)": "20 ½ - 22 ins"},
        {"Pant Size": "22 ins", "Waist Size (cm)": "57 - 61 cms", "Waist Size (in)": "22 ½ - 24 ins"},
        {"Pant Size": "24 ins", "Waist Size (cm)": "62 - 66 cms", "Waist Size (in)": "24 ½ - 26 ins"},
        {"Pant Size": "26 ins", "Waist Size (cm)": "67 - 71 cms", "Waist Size (in)": "26 ½ - 28 ins"}
      ]},
      "Fox": {"sizes": [
        {"Pant Size": "22 ins", "Waist Size (cm)": "58 cms", "Euro Size": "32"},
        {"Pant Size": "24 ins", "Waist Size (cm)": "61 cms", "Euro Size": "34"},
        {"Pant Size": "26 ins", "Waist Size (cm)": "64 cms", "Euro Size": "36"},
        {"Pant Size": "28 ins", "Waist Size (cm)": "66 cms", "Euro Size": "38"}
      ]},
      "Leatt": {"sizes": [
        {"Pant Size": "18 ins", "Waist Size (cm)": "46 - 48 cms", "Waist Size (in)": "18 - 19 ins"},
        {"Pant Size": "20 ins", "Waist Size (cm)": "51 - 53 cms", "Waist Size (in)": "20 - 21 ins"},
        {"Pant Size": "22 ins", "Waist Size (cm)": "56 - 58 cms", "Waist Size (in)": "22 - 23 ins"},
        {"Pant Size": "24 ins", "Waist Size (cm)": "61 - 63 cms", "Waist Size (in)": "24 - 25 ins"},
        {"Pant Size": "26 ins", "Waist Size (cm)": "66 - 68 cms", "Waist Size (in)": "26 - 27 ins"},
        {"Pant Size": "28 ins", "Waist Size (cm)": "71 - 73 cms", "Waist Size (in)": "28 - 29 ins"}
      ]},
      "Seven": {"sizes": [
        {"Pant Size": "18 ins", "Waist Size (cm)": "46 - 48 cms", "Waist Size (in)": "18 - 19 ins"},
        {"Pant Size": "20 ins", "Waist Size (cm)": "51 - 53 cms", "Waist Size (in)": "20 - 21 ins"},
        {"Pant Size": "22 ins", "Waist Size (cm)": "56 - 58 cms", "Waist Size (in)": "22 - 23 ins"},
        {"Pant Size": "24 ins", "Waist Size (cm)": "61 - 63 cms", "Waist Size (in)": "24 - 25 ins"},
        {"Pant Size": "26 ins", "Waist Size (cm)": "66 - 68 cms", "Waist Size (in)": "26 - 27 ins"},
        {"Pant Size": "28 ins", "Waist Size (cm)": "71 - 73 cms", "Waist Size (in)": "28 - 29 ins"}
      ]},
      "Troy Lee Designs": {"sizes": [
        {"Pant Size": "18 ins", "Waist Size (cm)": "46 - 48 cms", "Waist Size (in)": "18 - 19 ins"},
        {"Pant Size": "20 ins", "Waist Size (cm)": "51 - 53 cms", "Waist Size (in)": "20 - 21 ins"},
        {"Pant Size": "22 ins", "Waist Size (cm)": "56 - 58 cms", "Waist Size (in)": "22 - 23 ins"},
        {"Pant Size": "24 ins", "Waist Size (cm)": "61 - 63 cms", "Waist Size (in)": "24 - 25 ins"},
        {"Pant Size": "26 ins", "Waist Size (cm)": "66 - 68 cms", "Waist Size (in)": "26 - 27 ins"},
        {"Pant Size": "28 ins", "Waist Size (cm)": "71 - 73 cms", "Waist Size (in)": "28 - 29 ins"}
      ]}
    }
  };
  
  // Main function to initialize size guide
  function initializeSizeGuide() {
    const accordionGroup = document.querySelector('.fastrak_accordion-group');
    if (!accordionGroup || accordionGroup.getAttribute('data-initialized') === 'true') {
      return;
    }
    
    accordionGroup.innerHTML = '';
    processAllSizeData(sizeGuideData, accordionGroup);
    accordionGroup.setAttribute('data-initialized', 'true');
  }
  
  // Function to process all size data at once
  function processAllSizeData(allData, container) {
    if (!allData || Object.keys(allData).length === 0) {
      showError(container, 'No size guide data available.');
      return;
    }
    
    const categories = Object.keys(allData).map(categoryId => ({
      id: categoryId,
      name: categoryId.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
    }));
    
    categories.forEach(category => {
      const details = document.createElement('details');
      details.className = 'fastrak_disclosure';
      
      const summary = document.createElement('summary');
      summary.className = 'fastrak_disclosure__summary';
      // Split category name into main and age group
      let main = category.name;
      let group = '';
      const match = category.id.match(/^(.*?)-(adult|youth)$/i);
      if (match) {
        main = match[1].replace(/\b\w/g, l => l.toUpperCase());
        if (main.toLowerCase() === 'pant') main = 'Pants';
        group = match[2].toLowerCase();
      }
      summary.innerHTML = group
        ? '<span style="display:inline-block"><span style="font-weight:600">' + main.replace(/\b\w/g, l => l.toUpperCase()) + '</span><span style="font-weight:400;opacity:.7;font-size:.92em;vertical-align:middle;margin-left:4px">(' + (group === 'adult' ? 'Adults' : 'Youth') + ')</span></span>'
        : '<span style="font-weight:600">' + main + '</span>';
      details.appendChild(summary);
      
      const content = document.createElement('div');
      content.className = 'fastrak_disclosure__content fastrak_rte';
      
      const vendorSelectors = document.createElement('div');
      vendorSelectors.className = 'fastrak_size-vendor-selectors';
      vendorSelectors.setAttribute('data-category', category.id);
      
      const vendorTables = document.createElement('div');
      vendorTables.className = 'fastrak_size-vendor-tables';
      vendorTables.setAttribute('data-category', category.id);
      
      content.appendChild(vendorSelectors);
      content.appendChild(vendorTables);
      details.appendChild(content);
      
      container.appendChild(details);
      
      const categoryData = allData[category.id];
      const vendors = Object.keys(categoryData).map(vendorId => ({
        id: vendorId,
        name: vendorId
      }));
      
      vendors.forEach(vendor => {
        const btn = document.createElement('button');
        btn.className = 'fastrak_size-vendor-btn';
        btn.setAttribute('data-vendor', vendor.id);
        btn.textContent = vendor.name;
        
        const tableContainer = document.createElement('div');
        tableContainer.className = 'fastrak_size-vendor-table';
        tableContainer.setAttribute('data-vendor', vendor.id);
        tableContainer.style.display = 'none';
        
        const vendorData = categoryData[vendor.id];
        if (vendorData && vendorData.sizes && vendorData.sizes.length > 0) {
          renderSizeTable({
            vendor_name: vendor.name,
            sizes: vendorData.sizes
          }, tableContainer);
          tableContainer.setAttribute('data-loaded', 'true');
        } else {
          tableContainer.innerHTML = '<div class="fastrak_size-table-message">No size data available for this vendor.</div>';
        }
        
        btn.addEventListener('click', function() {
          const tables = vendorTables.querySelectorAll('.fastrak_size-vendor-table');
          const buttons = vendorSelectors.querySelectorAll('.fastrak_size-vendor-btn');
          const content = vendorTables.parentElement;
          const prevHeight = content.offsetHeight;
          tables.forEach(table => table.style.display = 'none');
          buttons.forEach(button => button.classList.remove('active'));
          this.classList.add('active');
          tableContainer.style.display = 'block';
          const nextHeight = content.offsetHeight;
          content.style.height = prevHeight + 'px';
          void content.offsetWidth;
          content.style.transition = 'height 0.3s';
          content.style.height = nextHeight + 'px';
          setTimeout(function() {
            content.style.height = '';
            content.style.transition = '';
          }, 300);
        });
        
        vendorSelectors.appendChild(btn);
        vendorTables.appendChild(tableContainer);
      });
      
      const firstBtn = vendorSelectors.querySelector('.fastrak_size-vendor-btn');
      if (firstBtn) {
        firstBtn.click();
      }
    });

    const allDetails = container.querySelectorAll('details');
    allDetails.forEach(detail => {
      const content = detail.querySelector('.fastrak_disclosure__content');
      
      detail.addEventListener('click', (e) => {
        if (e.target.closest('summary')) {
          e.preventDefault();
          
          allDetails.forEach(otherDetail => {
            if (otherDetail !== detail && otherDetail.hasAttribute('open')) {
              const otherContent = otherDetail.querySelector('.fastrak_disclosure__content');
              otherContent.style.height = otherContent.scrollHeight + 'px';
              setTimeout(() => {
                otherContent.style.height = '0';
                setTimeout(() => {
                  otherDetail.removeAttribute('open');
                  otherContent.style.height = '';
                }, 300);
              }, 10);
            }
          });

          if (detail.hasAttribute('open')) {
            const content = detail.querySelector('.fastrak_disclosure__content');
            content.style.height = content.scrollHeight + 'px';
            setTimeout(() => {
              content.style.height = '0';
              setTimeout(() => {
                detail.removeAttribute('open');
                content.style.height = '';
              }, 300);
            }, 10);
          } else {
            detail.setAttribute('open', '');
            content.style.height = '0';
            setTimeout(() => {
              content.style.height = content.scrollHeight + 'px';
              setTimeout(() => {
                content.style.height = '';
              }, 300);
            }, 10);
          }
        }
      });
    });
  }
  
  // Function to render size table from data
  function renderSizeTable(data, container) {
    if (!data || !data.sizes || data.sizes.length === 0) {
      container.innerHTML = '<div class="fastrak_size-table-message">No size data available for this vendor.</div>';
      return;
    }
    
    container.innerHTML = '';
    
    const vendorTitle = document.createElement('div');
    vendorTitle.className = 'fastrak_size-table-vendor';
    vendorTitle.textContent = data.vendor_name;
    container.appendChild(vendorTitle);
    
    const table = document.createElement('table');
    table.className = 'fastrak_size-table';
    
    const thead = document.createElement('thead');
    const headerRow = document.createElement('tr');
    
    Object.keys(data.sizes[0]).forEach(key => {
      const th = document.createElement('th');
      th.className = 'fastrak_size-table-header';
      th.textContent = key.replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase());
      headerRow.appendChild(th);
    });
    
    thead.appendChild(headerRow);
    table.appendChild(thead);
    
    const tbody = document.createElement('tbody');
    
    data.sizes.forEach((sizeRow, index) => {
      const tr = document.createElement('tr');
      if (index % 2 === 1) {
        tr.className = 'fastrak_size-table-row-alt';
      }
      
      Object.values(sizeRow).forEach(value => {
        const td = document.createElement('td');
        td.className = 'fastrak_size-table-cell';
        td.textContent = value;
        tr.appendChild(td);
      });
      
      tbody.appendChild(tr);
    });
    
    table.appendChild(tbody);
    container.appendChild(table);
  }
  
  // Helper function to show error message
  function showError(container, message) {
    const errorElement = document.createElement('div');
    errorElement.className = 'fastrak_size-table-error';
    errorElement.textContent = message;
    container.appendChild(errorElement);
  }
}); 